import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { LayoutInterface } from 'ui/uiTypes';

import { RightLink } from './style';

const RightItemSideNonLogg: React.FC<LayoutInterface> = ({
  rightNonLoggMenu,
}) => {
  const router = useRouter();
  return (
    <>
      {rightNonLoggMenu?.map((menu) => (
        <RightLink active={router.pathname === menu.link} key={menu.link}>
          <Link href={menu.link} data-testid={menu.label}>
            {menu.label}
          </Link>
        </RightLink>
      ))}
    </>
  );
};

export default RightItemSideNonLogg;
